import UIFooter from './UIFooter'
export default UIFooter
